import { app } from '../../../../app';
import { Controller } from './sms-purchase-invoice.controller';

app.component('companySmsServicesInvoice', {
    bindings: {
        invoice: '<',
        payment: '<',
        settings: '<',
    },
    controller: Controller,
    templateUrl: require('./sms-purchase-invoice.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/invoice/sms-purchase-invoice.component.js